const Phase = {
    Political: "Political",
    Action: "Action",
    // The game is over (see GameEnd.js)
    GameOver: "GameOver",
}

const MoveTypes = {
    PassPoliticalPhase: "PassPoliticalPhase",
    TakeCard: "TakeCard",
    IncreasePopulation: "IncreasePopulation",
    Build: "Build",
    DiscoverTechnology: "DiscoverTechnology",
    Upgrade: "Upgrade",
    Destroy: "Destroy",
    PlayLeader: "PlayLeader",
    PlayActionCard: "PlayActionCard",
    OceanLinerPopulation: "OceanLinerPopulation",
    BarbarossaRecruit: "BarbarossaRecruit",
    BachUpgrade: "BachUpgrade",
    ChurchillTake: "ChurchillTake",
    ChangeGovernment: "ChangeGovernment",
    ColumbusColonize: "ColumbusColonize",
    AlexanderRetire: "AlexanderRetire",
    CatherineDecree: "CatherineDecree",
    CoubertinOlympics: "CoubertinOlympics",
    LouvreSpend: "LouvreSpend",
    RedCrossStage: "RedCrossStage",
    PlayAggression: "PlayAggression",
    DeclareWar: "DeclareWar",
    OfferPact: "OfferPact",
    Resign: "Resign",
    Withdraw: "Withdraw",
    CancelPact: "CancelPact",
    BuildWonderStage: "BuildWonderStage",
    PrepareEvent: "PrepareEvent",
    PlayTactic: "PlayTactic",
    CopyTactic: "CopyTactic",
    DiscardMilitaryCards: "DiscardMilitaryCards",
    EndTurn: "EndTurn",
    Decide: "Decide",
}

module.exports = {
    Phase,
    MoveTypes,
}
